export function getDownloadFilename(headers, fallback) {
  const disposition = headers?.['content-disposition'] || headers?.['Content-Disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const filename = match?.[1];
  return /^\d{6}_.+-Attendance\.xlsx$/i.test(filename || '') ? filename : fallback;
}

function cleanFilenamePart(value) {
  return String(value ?? '')
    .trim()
    .replace(/[^a-z0-9-]+/gi, '_')
    .replace(/^_+|_+$/g, '');
}

function formatFilenameDate(value) {
  const match = String(value ?? '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[1].slice(-2)}${match[2]}${match[3]}` : '000000';
}

function parseList(value) {
  if (Array.isArray(value)) return value;
  if (typeof value !== 'string' || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch (_) {
    return [value];
  }
}

function commonValue(values) {
  const unique = [...new Set(
    values
      .filter(value => value !== null && value !== undefined && String(value).trim())
      .map(value => String(value).trim())
  )];
  return unique.length === 1 ? unique[0] : '';
}

export function commonSessionIntake(sessions = []) {
  return commonValue(sessions.flatMap(session => parseList(session?.intakes)));
}

export function commonSessionModule(sessions = []) {
  return commonValue(sessions.map(session => session?.schedule_name));
}

export function sessionIntakeLabel(sessions = []) {
  const intakes = [...new Set(
    sessions
      .flatMap(session => parseList(session?.intakes))
      .filter(value => value !== null && value !== undefined && String(value).trim())
      .map(value => String(value).trim())
  )].sort();

  if (intakes.length === 0) return '';
  return intakes.length === 1 ? intakes[0] : `Multiple-${intakes.join('_')}`;
}

export function buildAttendanceExportFilename({ date, intakeCode, moduleCode, period }) {
  const parts = [formatFilenameDate(date)];
  const periodPart = cleanFilenamePart(period);
  if (periodPart) parts.push(periodPart);
  parts.push(cleanFilenamePart(intakeCode) || 'All-Intakes');
  const modulePart = cleanFilenamePart(moduleCode);
  if (modulePart && modulePart !== '-') parts.push(modulePart);
  return `${parts.join('_')}-Attendance.xlsx`;
}
